import $ from 'jquery';
import 'slick-carousel';

const heroFeatureSlider = document.querySelector('.hero-feature-slider');
const prevArrow = document.querySelector('.hero-feature-slider-wrapper .prev-button');
const nextArrow = document.querySelector('.hero-feature-slider-wrapper .next-button');
if (heroFeatureSlider) {
  $(heroFeatureSlider).slick({
    autoplay: true,
    autoplaySpeed: 7000,
    dots: true,
    prevArrow,
    nextArrow,
  });
}
